import * as React from "react"

import { StaticImage } from "gatsby-plugin-image";

import * as S from './styles';

export default function CompletelySafe() {
  return (
    <S.Container>
      <S.Content>
        <S.Text>
          <h1 className="title-normal">Work with top brands!</h1>
          <p>We connect you to some of the worlds top and upcoming retail brands. From Fashion to upcoming mobile apps, we have you covered!</p>
          <p>With our tried and tested process, we can help get your foot in the door whilst getting paid!</p>
        </S.Text>
        <S.Images>
          <StaticImage
            src={`../../images/top-brands-2.png`}
            alt="Working out"
            placeholder="blurred"
            layout="constrained"
            quality="40"
          />
        </S.Images>
        {/* <h1 className="title-responsive">Work with top brands!</h1> */}
      </S.Content>
    </S.Container>
  )
}